import ScatterPlotViz from '../vizs/ScatterPlotViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * Used to display values for typically two variables for a set of data. If the points are coded (color/shape/size), one additional variable can be displayed. The data are displayed as a collection of points, each having the value of one variable determining the position on the horizontal axis and the value of the other variable determining the position on the vertical axis.
 *  
 * ### Example Usage
 * ```javascript
 *   
 *   import {ScatterPlot} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new ScatterPlot($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 or 4 columns.
 * 
 * Each row represents a data point.
 * 
 * The first column should represent the id/label of the data point.
 * 
 * The second and third columns should represent the X and Y coordinates of the point.
 * 
 * The fourth column (optional) should represent the color group to which the point belongs.
 * 
 * Note: the x and y coordinates can be numebers or strings, and will be sorted in the orther in which they appear in the table.
 * 
 * | id   |  x    | y    |  color |
 * | ---- | ---   | ---- | -----  |
 * |  a   |  14.2 | 24.2 | group1 |
 * |  b   |  52.3 | 51.2 | group1 |
 * |  c   |  16.3 | 21.6 | group2 |
 * |  d   |  43.0 | 18.2 | group2 |
 * 
 * 
 * {.data-table}
 * 
 * */
export default class ScatterPlotComponent extends BaseComponent {
  static vizClass = ScatterPlotViz
  static dataFormat = [
    {index:0,axis:'',label:'id',types:[String],role:'id',roleLabel:'Item'},
    {index:1,axis:'x0',label:'x value',types:[Number,Date],role:'value',roleLabel:'X value - Number or Date (dd-mm-yyyy)'},
    {index:2,axis:'y0',label:'x value',types:[Number],role:'value',roleLabel:'Y value'},
    {index:3,axis:'',label:'color',types:[String],role:'value',roleLabel:'Category/Color'},
  ]
  static componentLabel = "Scatter plot"
  static defaultConfig = {
    title: this.componentLabel,
    
  }
}